import { Accordion } from '@studiometa/ui';
import { CollapseItem } from './CollapseItem.js';
/**
 * Collapse class.
 */
export default class Collapse extends Accordion {
  /**
   * Class config.
   * @type {object}
   */
  static config = {
    name: 'Collapse',
    options: { ...Accordion.config.options },
    components: {
      CollapseItem,
    },
  };

  /**
   * openItem
   * @param {number} nid
   */
  openItem(nid) {
    const filteredItem = this.$children.CollapseItem.find((x) => x.$refs.title.id === nid);
    if (filteredItem) {
      filteredItem.open();
    }
  }
}
